import type { FilterColumnType } from './operators';

/** Карта колонок таблицы проектов → тип UI-фильтра. */
export const PROJECT_COLUMN_FILTER_TYPES: Record<string, FilterColumnType> = {
  name: 'text',
  author: 'text',
  theme: 'text',
  rights: 'text',
  asta: 'text',
  ase: 'text',
  rin: 'text',
  paper_book_plan: 'text',
  producer: 'text',
  techeditor: 'text',
  corrector: 'text',
  editor: 'text',
  edition: 'text',
  department: 'text',
  state: 'select',
  project_type: 'select',
  review_check_type: 'select',
  project_phonogram: 'select',
  project_dp: 'select',
  project_pdf: 'select',
  has_music: 'boolean',
  readers: 'multiPerson',
  studio: 'multiPerson',
  deadline: 'date',
  review_deadline: 'date',
  corrections_number: 'number',
  pages: 'number',
  author_sheets: 'number',
  recording_coef: 'number',
  montage_coef: 'number',
  project_approved: 'select',
  project_done: 'select',
  no_edits: 'boolean',
};
